// src/components/Metrics.jsx
import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import {
  FaCheckCircle,
  FaUsers,
  FaAward,
  FaClock,
} from 'react-icons/fa';
import '../styles/about.scss';

const METRICS = [
  { value: 250, label: 'Projects completed', Icon: FaCheckCircle },
  { value: 150, label: 'Satisfied clients', Icon: FaUsers },
  { value: 50,  label: 'Awards won',         Icon: FaAward },
  { value: 10,  label: 'Years of experience', Icon: FaClock },
];

function Metrics() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <section className="metrics" ref={ref}>
      {/* Decorative layers */}
      <div className="metrics-pattern" />
      <span className="metrics-glow metrics-glow-1" />
      <span className="metrics-glow metrics-glow-2" />

      <div className="metrics-content">
        {METRICS.map(({ value, label, Icon }, idx) => (
          <div className="metric-box" key={idx}>
            <span className="metric-icon">
              <Icon />
            </span>

            <h2 className="metric-value">
              {inView ? <CountUp end={value} duration={5} /> : 0}
              <span className="metric-plus">+</span>
            </h2>

            <p className="metric-label">{label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Metrics;